export { default } from './ForecastGraphConsistency';
